"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsomorphicClerkContext = exports.IsomorphicClerkContext = void 0;
const shared_1 = require("@clerk/shared");
_a = [shared_1.ClerkInstanceContext, shared_1.useClerkInstanceContext], exports.IsomorphicClerkContext = _a[0], exports.useIsomorphicClerkContext = _a[1];
